import React from "react";

import { UIButtonProps } from "./UIButton";

export interface UIButtonClickProps extends UIButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export default UIButtonClick;

function UIButtonClick(props: UIButtonClickProps) {
  const classNames: string[] = ["button", props.kind || "page"];

  if (props.className) {
    classNames.push(props.className);
  }

  return (
    <button type={props.type || "button"} className={classNames.join(" ")} style={props.style} {...props.attrs} onClick={props.onClick}>
      {props.children != null ? (
        props.children
      ) : (
        <>
          {props.icon ? <img src={props.icon} alt={props.label} /> : null}
          {props.label}
        </>
      )}
    </button>
  );
}
